import {
    Percent,
    Palmtree,
    Coffee,
    Gem,
    Hotel,
} from "lucide-react";

export default function OfferBar() {
    const offers = [
        {
            text: "20% OFF on Dubai Luxury Hotels",
            icon: Percent,
        },
        {
            text: "Beach Resorts Starting from AED 199",
            icon: Palmtree,
        },
        {
            text: "Free Breakfast on Selected Stays",
            icon: Coffee,
        },
        {
            text: "Weekend Flash Deals - Limited Time",
            icon: Gem,
        },
        {
            text: "Book Early & Save Extra 15%",
            icon: Hotel,
        },
    ];

    return (
        <div className="bg-gradient-to-r from-blue-600 via-cyan-500 to-blue-700 text-white py-2 overflow-hidden">
            <div className="whitespace-nowrap animate-scroll flex gap-10 px-4">
                {offers.concat(offers).map((offer, index) => {
                    const Icon = offer.icon;

                    return (
                        <span
                            key={index}
                            className="
                                flex
                                items-center
                                gap-2
                                font-medium
                                text-sm
                                uppercase
                                tracking-wide
                            "
                        >
                            <Icon
                                size={18}
                                strokeWidth={2}
                                className="text-white"
                            />

                            {offer.text}
                        </span>
                    );
                })}
            </div>
        </div>
    );
}